"use client";
import PageLayout from "components/PageLayout/PageLayout";
import ProductAttributes from "components/ProductDetail/ProductAttributes/ProductAttributes";
import ProductInformation from "components/ProductDetail/ProductInformation/ProductInformation";
import ProductProperties from "components/ProductDetail/ProductProperties/ProductProperties";
import ProductTitle from "components/ProductDetail/ProductTitle/ProductTitle";
import RelatedProducts from "components/ProductDetail/RelatedProducts";
import useMediaQuery from "hooks/useMediaQuery";
import { useState } from "react";

const ProductPage = ({ preparation_packages, page }) => {
  const [selectedVariationId, setSelectedVariationId] = useState(null);
  const product = page?.product;
  const cross_sells = page?.cross_sells;
  const breadcrumbs_arr = product?.bread_crumb_categories_arrays;

  const breadcrumbs = Array.isArray(breadcrumbs_arr)
    ? [...breadcrumbs_arr, { name: product?.title }]
    : [
      breadcrumbs_arr ? breadcrumbs_arr : { name: "Geen categorie" },
      { name: product?.title },
    ];

  const categories = product?.categories || [];
  const images = product?.variations?.images || {};
  const product_attributes = product?.properties;
  const selected_image = images?.[selectedVariationId] || null;
  const isLarge = useMediaQuery("(min-width: 1024px)");

  return (
    <>
      <PageLayout breadcrumbs={breadcrumbs}>
        <section className="px-4 mx-auto mb-10 md:mb-20 xl:px-0 max-w-app">
          <div className="mb-4 lg:hidden">
            <ProductTitle categories={categories} title={product?.title} />
          </div>

          <div className="flex lg:gap-6">
            <div className="lg:w-[calc(58%-0.75rem)] w-full">
              <ProductInformation
                showProperties={!isLarge}
                product={product}
                page={page}
                selected_image={selectedVariationId ? { ...selected_image, variation_id: selectedVariationId } : null}
                preparation_packages={preparation_packages}
                setSelectedVariationId={setSelectedVariationId}
              />
            </div>

            {isLarge && (
              <div className="sticky w-[calc(42%-0.75rem)] h-full top-28 flex flex-col gap-3">
                <ProductTitle categories={categories} title={product?.title} />
                <ProductAttributes product_attributes={product_attributes} />
                <ProductProperties
                  page={page}
                  selected_image={selected_image}
                  preparation_packages={preparation_packages}
                  setSelectedVariationId={setSelectedVariationId}
                />
              </div>
            )}
          </div>
        </section>
        {cross_sells?.length > 0 && (
          <RelatedProducts relatedProducts={cross_sells} />
        )}
      </PageLayout>
    </>
  );
};

export default ProductPage;